export class MessageType{
  public static msgError:string   = 'ERROR';
  public static msgWarning:string = 'WARNING';
  public static msgMessage:string = 'MESSAGE';
  public static msgSuccess:String = 'SUCCESS';
  public static msgCancel:String  = 'CANC';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/models/message-type.config.ts